import { getV1JWTWithoutRefresh } from '../util/jwt_helper'
import BaseService from './BaseService'

class LogsService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }

  metric = async (data: { [key: string]: any }) => {
    try {
      const index = `frontend-performance-${new Date().toISOString().split('T')[0]}`
      const response = await this.noJWTInstance.post(`/metric`, { index, body: data }, {
        headers: {
          ...this.headers,
          authorization: `Bearer ${getV1JWTWithoutRefresh()}`,
        },
      })

      return response
    } catch (error) {
      console.error(error)
    }
  }

  dump = async (indexPrefix: string, data: { [key: string]: any }) => {
    try {
      const index = `${indexPrefix}-${new Date().toISOString().split('T')[0]}`
      const response = await this.noJWTInstance.post(`/metric`, { index, body: data }, {
        headers: {
          ...this.headers,
          authorization: `Bearer ${getV1JWTWithoutRefresh()}`,
        },
      })
      return response
    } catch (error) {
      console.error(error)
    }
  }
}

const instance = new LogsService(BaseService.servicesConfig.Logs as string)

export default instance
